"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NfaState = void 0;
var CharMatcher_1 = require("./CharMatcher");
var NfaState = /** @class */ (function () {
    /** @constructor */
    function NfaState(charMatcher) {
        this.next = [];
        this.id = CharMatcher_1.getNextStateId(); //NextStateId++;
        this.lastList = 0;
        this.accept = undefined;
        this.mchar = charMatcher;
    }
    NfaState.prototype.toString = function () {
        var str = '\nState [' + this.id + '] ch=' + this.mchar + '\n';
        if (this.accept !== undefined) {
            str += '    Accept ' + this.accept + '\n';
        }
        for (var i = 0; i < this.next.length; i++) {
            str +=
                '    ch=' + this.next[i].mchar + ' goto [' + this.next[i].id + ']\n';
        }
        return str;
    };
    return NfaState;
}());
exports.NfaState = NfaState;
//# sourceMappingURL=NfaState.js.map